
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      $global_formOpts: {
        labelWidth: {
          normal: '108px'
        }
      }
    }
  },
  methods: {
    $_global_resetForm(form) {
      this.$refs[form].resetFields();
    }
  },
  computed: {
    ...mapGetters(["authority"]),
  },
};
